import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DISCIPLINE_OPTIONS } from "./utils/mapers";

const DisciplineContext = createContext(null);

const STORAGE_KEY = "redfid_discipline_filter";

export function DisciplineProvider({ children }) {
  const [discipline, setDiscipline] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "general";
    } catch {
      return "general";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, discipline);
    } catch {}
  }, [discipline]);

  const value = useMemo(
    () => ({ discipline, setDiscipline, options: DISCIPLINE_OPTIONS }),
    [discipline]
  );

  return (
    <DisciplineContext.Provider value={value}>
      {children}
    </DisciplineContext.Provider>
  );
}

export function useDisciplineFilter() {
  const ctx = useContext(DisciplineContext);
  if (!ctx) {
    throw new Error("useDisciplineFilter must be used within DisciplineProvider");
  }
  return ctx;
}